import styled from "styled-components";
import LandingFooter from "../components/features/Landing/LandingFooter";
import "../styles/landingMobile.css";
import LandingTitle from "../components/features/Landing/LandingTitle";
import { BackgroundImage } from "../styles/common";
import SatelliteImage from "../components/features/Landing/LandingImage";
import Branding from "@/components/features/Landing/Branding";
import withAuth from "@/components/shared/utils/Auth/Auth";

const LandingPage = () => {
  return (
    <>
      <LandingPageLayout className="landing__layout">
        {/* <ImageWrapper className="landing__image"></ImageWrapper> */}
        <ContentWrapper className="landing__content">
          <LandingTitle />
        </ContentWrapper>
        <ImageWrapper>
          <SatelliteImage />
        </ImageWrapper>
        <FooterWrapper className="landing__footer">
          <LandingFooter />
        </FooterWrapper>
      </LandingPageLayout>
      {/* <BackgroundImage /> */}
    </>
  );
};

export default LandingPage;

const LandingPageLayout = styled.div`
  width: 100%;
  height: calc(100vh - 7rem - 2px);
  z-index: 2;
  display: grid;
  grid-template-columns: [column1] 1fr [column2] 1fr [column3];
  grid-template-rows: [row1] 2fr [row2] 1fr [row3];

  @media screen and (max-width: 768px) {
    grid-template-columns: [column1] 1fr [column2];

    grid-template-rows: [row1] 1fr [row2] 1fr [row3] 2fr [row4];
  }
`;

// const ImageWrapper = styled.div`
//   grid-area: row1 / column2 / row2 / column3;
// `;
const ImageWrapper = styled.section`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  grid-area: row1 / column2 / row2 / column3;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const ContentWrapper = styled.main`
  grid-area: row1 / column1 / row2 / column2;
`;

const FooterWrapper = styled.footer`
  grid-area: row2 / column1 / row3 / column3;
  /* @media screen and (max-width: 768px) {
    grid-area: row3 / column1 / row4 / column2;
  } */
`;
